import axios from 'axios'
axios.defaults.baseURL = '/v3-api';
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8'
axios.defaults.withCredentials = true
export default axios
